import React, { useState } from 'react';

import { AiFillPlusCircle } from 'react-icons/ai';
import { AiOutlineCloseSquare } from 'react-icons/ai';
import { BiSearch } from 'react-icons/bi';
import { TiArrowBack } from 'react-icons/ti';
import { IoMdRefresh } from "react-icons/io";

import { useHistory } from 'react-router-dom';

import Notifications from './Notifications';
import Connection from './Connection';

import { Container, Content, Title, Right, Search, PlusBtn } from './styles';

import { HeaderProps } from './interface';

const Header: React.FC<HeaderProps> = ({
  title,
  plus,
  plusLabel,
  subtitle,
  onSearch,
  isSearch,
  placeholder,
  back,
  isRefresh,
  onRefresh
}) => {
  const history = useHistory();

  const [searchStr, setSearchStr] = useState('');

  const searching = () => {
    if (onSearch) {
      onSearch(searchStr);
    }
  };

  const clearSearching = () => {
    setSearchStr('');
    if (onSearch) {
      onSearch('');
    }
  };

  const onPlus = (pPage: string) => {
    history.push(`/${pPage}/0`);
  };

  const onBack = () => {
    if (back) {
      history.push(`${back}`);
    }
  };

  return (
    <>
      <Notifications />
      <Connection />
      <Container>
        <Content>
          <Title>
            {back ? (
              <button onClick={onBack}>
                <TiArrowBack size={32} color="#333" />
              </button>
            ) : null}
            {isRefresh ? (
              <button onClick={onRefresh}>
                <IoMdRefresh size={32} color="#555" />
              </button>
            ) : null}
            <div>
              {title ? <h1>{title}</h1> : null}
              {subtitle ? <h2>{subtitle}</h2> : null}
            </div>
          </Title>

          <Right>
            {isSearch ? (
              <Search>
                <input
                  type="text"
                  placeholder={placeholder}
                  value={searchStr}
                  onChange={e => setSearchStr(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      searching();
                    }
                  }}
                />
                {searchStr ? (
                  <button
                    type="button"
                    onClick={clearSearching}
                    className="close"
                  >
                    <AiOutlineCloseSquare size={22} color="#555" />
                  </button>
                ) : null}
                <button type="button" onClick={searching} className="search">
                  <BiSearch size={32} color="#333" />
                </button>
              </Search>
            ) : null}

            {plus ? (
              <PlusBtn onClick={() => onPlus(plus)}>
                <AiFillPlusCircle size={32} color="#fff" />
                <span>{plusLabel ? plusLabel : ''}</span>
              </PlusBtn>
            ) : null}
          </Right>
        </Content>
      </Container>
    </>
  );
};

export default Header;
